<div class="grid">
  <div class="col-12">
    <div class="card title-card">
      <div role="toolbar">
        <div class="flex align-items-center">
          <div>
            <i class="pi pi-plus-circle mr-1 title-card-icon"></i>
          </div>
          <div>
            <p class="h1-font-size title">{{'preview.creationForm' | transloco}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="lg:col-4 md:col-12 pb-0">
    <p-timeline [value]="previewSteps" align="left" styleClass="timeline-hidden-opposite">
      <ng-template pTemplate="marker" let-item>
        <span class="custom-marker p-shadow-1"
              [class]="(item.index != currentStep) ? (item.index < currentStep) ? 'step-completed' : 'step-inactive' : 'step-active'">
            <i class="white" [ngClass]="(item.index >= currentStep) ? item.icon : 'pi pi-check'"></i>
        </span>
      </ng-template>
      <ng-template pTemplate="content" let-item>
        <div class="card {{item.index != 4 ? 'mb-3' : ''}}">
          <h4 [class]="(item.index != currentStep) ? 'step-text-inactive' : 'step-text-active'">{{item.label}}</h4>
          <div *ngIf="item.description">{{item.description}}</div>
        </div>
      </ng-template>
    </p-timeline>
  </div>

  <div class="lg:col-8 md:col-12 pb-0">
    <div class="card flex flex-column h-full">
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-6">
          <div class="form-field col-12">
            <label for="serialNumber">{{'preview.identifier' | transloco}} (*)</label>
          </div>
          <div class="col-12">
            <input pInputText id="serialNumber" type="text" class="w-full">
          </div>
        </div>
        <div class="col-12 md:col-12 lg:col-6">
          <div class="form-field col-12">
            <label for="description">{{'preview.description' | transloco}}</label>
          </div>
          <div class="col-12">
            <input pInputText id="description" type="text" class="w-full">
          </div>
        </div>
        <div class="col-12 md:col-12 lg:col-6">
          <div class="form-field col-12">
            <label>{{'preview.status' | transloco}}</label>
          </div>
          <div class="col-12">
            <p-selectButton [options]="statusOptions" [(ngModel)]="statusOption" ></p-selectButton>
          </div>
        </div>
      </div>

      <div class="mt-auto">
        <div class="flex flex-column sm:flex-row justify-content-between">
          <div class="flex justify-content-between sm:justify-content-start sm:flex-order-1">
            <button pButton pRipple class="flex-1 sm:flex-none p-button-primary"
                    icon="pi pi-angle-left" iconPos="left" label="{{'common.previous' | transloco}}"></button>
            <button pButton pRipple class="ml-2 flex-1 sm:flex-none p-button-primary"
                    icon="pi pi-angle-right" iconPos="right" label="{{'common.next' | transloco}}"></button>
          </div>
          <button pButton pRipple class="p-button-danger mt-2 sm:mt-0 sm:flex-order-0"
                  label="{{'common.cancel' | transloco}}"></button>
        </div>
      </div>

    </div>
  </div>
</div>
